import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { buttonSX } from '@/components/blocks/DpLibrary/DpButtonForm/style/main';
import { Stack } from '@mui/material';

export const DpButtonForm = ({ label, onClick }: { label: string; onClick?: () => void }) => (
	<Stack alignItems="center">
		<DpButton type="submit" sx={buttonSX} onClick={onClick}>
			{label}
		</DpButton>
	</Stack>
);
